import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Language from "../components/mod/language";
import Aside from "../components/common/Aside";

function Header() {
  const [logo, setLogo] = useState("");
  const [showLanguage, setShowLanguage] = useState(false);
  const [asideOpen, setAsideOpen] = useState(false);

   const [isLoggedIn, setIsLoggedIn] = useState(false);
  
    useEffect(() => {
      // 🔍 check token from localStorage
      const token = localStorage.getItem("token");
      if (token && token !== "null" && token !== "undefined") {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }, []);

useEffect(() => {
  const html = document.documentElement;

  if (asideOpen) {
    // remove any unwanted inline styles (from google translate etc.)
    html.removeAttribute("style");
    // add class to lock scroll
    html.classList.add("overflow-y-hidden");
  } else {
    // remove class when aside closed
    html.classList.remove("overflow-y-hidden");
    // ensure inline style fully cleared
    html.removeAttribute("style");
  }

  // cleanup (safety on unmount)
  return () => {
    html.classList.remove("overflow-y-hidden");
    html.removeAttribute("style");
  };
}, [asideOpen]);

  // ✅ Fetch logo
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch logo");
        const data = await response.json();
        setLogo(`${process.env.REACT_APP_API_URL}/storage/${data[0].logo}`);
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };
    fetchLogo();
  }, []);

  return (
    <>
      <div className="row no-gutters">
        <div className="full-width hidden-md-and-up header-top mobile elevation-3 col col-12">
          <div className="row no-gutters align-center">
            <div className="px-3 col col-12">
              <div className="row no-gutters align-center justify-space-between">
                <div className="text-left col col-1">
                  <button
                    type="button"
                    onClick={() => setAsideOpen(true)} 
                    className="v-app-bar__nav-icon v-btn v-btn--icon v-btn--round theme--dark v-size--default"
                    style={{ height: "18px", width: "22px" }}
                  >
                    <span className="v-btn__content">
                      <i aria-hidden="true" className="v-icon notranslate mdi mdi-menu theme--dark" />
                    </span>
                  </button>
                </div>

                <div className="mobile-header-logo col col-9">
                  <Link
                    to="/"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img src={logo} alt="Logo" width={215} height={50} style={{ paddingLeft: "10px" }} />
                  </Link>
                </div>
              <div className="text-right col col-2">
  {!isLoggedIn ? (
    <button
      type="button"
      onClick={() => setShowLanguage(true)}
      className="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default"
      style={{
        width: "55px",
        cursor: "pointer",
        backgroundColor: "transparent",
        paddingLeft: "5px",
        border: "1px solid rgb(245, 245, 245)",
      }}
    >
      <span className="v-btn__content">
        <div
          className="v-avatar language-button"
          style={{ height: "25px", minWidth: "25px", width: "25px" }}
        >
          <img
            src="./static/image/country/BDT.svg"
            alt="BDT"
          />
        </div>
        <i
          aria-hidden="true"
          className="v-icon notranslate mdi mdi-menu-down theme--dark"
        />
      </span>
    </button>
  ) : (
    <a
    
      className="v-btn v-btn--icon v-btn--round v-btn--router theme--dark v-size--default"
    >
      <span className="v-btn__content">
        <span className="v-badge v-badge--bottom v-badge--dot v-badge--left theme--dark">
          <i
            aria-hidden="true"
            className="v-icon notranslate white-text material-icons theme--dark"
            style={{ fontSize: "32px" }}
          >
            email
          </i>
          <span className="v-badge__wrapper">
            <span
              aria-atomic="true"
              aria-label="Badge"
              aria-live="polite"
              role="status"
              className="v-badge__badge transparent"
              style={{
                inset: "calc(100% - 8px) calc(100% - 5px) auto auto",
              }}
            />
          </span>
        </span>
      </span>
    </a>
  )}
</div>
           


                <div className="spacer" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showLanguage && (
        <Language onClose={() => setShowLanguage(false)} />
      )}
      {asideOpen && (
      <Aside asideToggle={asideOpen} setAsideOpen={setAsideOpen} logo={logo} onClose={() => setAsideOpen(false)} />
      )}
    </>
  );
}

export default Header;
